import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import MyVisitsTableHeader from './MyVisitsTableHeader';
import { BaseTableRQ, OptionItem } from 'components/common/models/BaseClass';
import PageHeader from 'components/common/PageHeader';
import MyVisitsModal from './MyVisitsModal';
import { usePaginationBe } from 'hooks/useBeHandle';
import useHandleModal from 'hooks/useHandleModal';
import { search as searchSaleCust } from 'services/salesperson-kpi/saleCustService';
import { getCustomers } from 'services/salesperson-kpi/customerService';
import ProspectTable from './CustomerTable/ProspectCustTable';
import NewCustTable from './CustomerTable/NewCustTable';
import PropTypes from 'prop-types';
import MyVisitFilter from './MyVisitFilter';
import { joinDataMultiDropdown } from 'helpers/dropdownFuncHelper';

const MyVisitsDashboard = ({ isFromManagerPage = false }) => {
  const defaultRQ = {
    ...new BaseTableRQ(1, 12),
    customerTypeId: 0,
    isFromManagerPage
  };

  const [visits, setMyVisits] = useState([]);
  const [customerSource, setCustomerSource] = useState([]);
  const [total, setTotal] = useState(0);

  const [isFilter, setIsFilter] = useState(false);
  const [filter, setFilter] = useState({ ...defaultRQ });
  const [filterForm, setFilterForm] = useState({});
  const [custType, setCustType] = useState(0);

  useEffect(() => {
    loadMyVisits(defaultRQ);
  }, []);

  useEffect(() => {
    getCustomers()
      .then(res => {
        if (res) {
          let source = res?.data.map(
            x => new OptionItem(`${x.id}_${x.isProspect}`, x.name, x)
          );
          setCustomerSource(source);
        }
      })
      .catch(err => console.log(err));
  }, []);

  const { isModal, dataModal, openModal, closeModal, submitModal } =
    useHandleModal(() => {
      loadMyVisits(defaultRQ);
    });

  const loadMyVisits = rq => {
    searchSaleCust(rq)
      .then(res => {
        if (res) {
          setMyVisits(res.items);
          setTotal(res.total);
        }
      })
      .catch(err => console.log(err));

    setFilter(rq);
  };

  const toggelFilter = () => {
    const newState = !isFilter;
    setIsFilter(newState);

    if (!newState) {
      setFilterForm({});
      let rq = {
        ...defaultRQ,
        customerTypeId: custType
      };
      loadMyVisits(rq);
    }
  };
  const { gotoPage, nextPage, previousPage } = usePaginationBe(
    filter,
    total,
    loadMyVisits
  );

  const handleChange = (field, value) => {
    setFilterForm({
      ...filterForm,
      [field]: value
    });
  };

  const handleFilterSubmit = () => {
    let rq = {
      ...defaultRQ,
      ...mapRQData(filterForm),
      customerTypeId: custType
    };
    loadMyVisits(rq);
  };

  const handleChangeCustType = value => {
    setCustType(value);

    if (isFilter) {
      let rq = {
        ...defaultRQ,
        ...mapRQData(filterForm),
        customerTypeId: value
      };
      loadMyVisits(rq);
    } else {
      let rq = {
        ...defaultRQ,
        customerTypeId: value
      };
      loadMyVisits(rq);
    }
  };

  const mapRQData = data => {
    if (!data) return {};
    let mapRq = { ...data };
    mapRq.saleIds = joinDataMultiDropdown(data?.saleIds);
    return mapRq;
  };

  return (
    <>
      <PageHeader
        title={'Log visit'}
        description={
          isFromManagerPage
            ? 'Manage and view sales visits'
            : `Manage and view your visits from this page.`
        }
        className="mb-3"
      />

      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <Row style={{ padding: '10px' }}>
              <MyVisitsTableHeader
                toggelFilter={toggelFilter}
                toggelModal={() => openModal()}
                style={{ padding: '10px' }}
                custType={custType}
                setCustType={handleChangeCustType}
                isFromManagerPage={isFromManagerPage}
              />

              {isFilter && isFromManagerPage && (
                <Col
                  lg={12}
                  style={{
                    padding: '17px',
                    paddingTop: '8px',
                    paddingBottom: '8px'
                  }}
                >
                  <MyVisitFilter
                    displayOption={{
                      showHeader: true,
                      showFooter: true,
                      col: '6'
                    }}
                    style={{
                      paddingBottom: '10px',
                      maxHeight: '250px',
                      overflowY: 'auto'
                    }}
                    handleChange={handleChange}
                    formData={filterForm}
                    handleSubmit={handleFilterSubmit}
                  />
                </Col>
              )}

              {custType === 0 || custType === 2 ? (
                <ProspectTable
                  data={visits}
                  paging={filter}
                  total={total}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  gotoPage={gotoPage}
                  handleClickRow={row => {
                    if (row) {
                      openModal(row.original);
                    }
                  }}
                />
              ) : (
                <NewCustTable
                  data={visits}
                  paging={filter}
                  total={total}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  gotoPage={gotoPage}
                  handleClickRow={row => {
                    if (row) {
                      openModal(row.original);
                    }
                  }}
                />
              )}
            </Row>
          </Card>
        </Col>
      </Row>

      <MyVisitsModal
        isShow={isModal}
        customerSource={customerSource}
        handleClose={closeModal}
        data={dataModal}
        handleSubmit={submitModal}
      />
    </>
  );
};

MyVisitsDashboard.propTypes = {
  page: PropTypes.number,
  size: PropTypes.number,
  isFromManagerPage: PropTypes.bool
};

export default MyVisitsDashboard;
